import React from "react";
import Text from "@amzn/meridian/text";

const ResetTimeTab: React.FC = () => (
  <Text>Reset Time settings coming soon.</Text>
);

export default ResetTimeTab;
